import { ShieldPlus, Anchor, Zap, Sparkles, Activity, Layers, ArrowRight } from "lucide-react";

const SERVICES = [
  { icon: ShieldPlus, title: "Dental Check-ups & Preventive Care", text: "Thorough exams, scaling and cleaning, and a clear plan to keep your teeth healthy.", reason: "general-checkup" },
  { icon: Anchor, title: "Dental Implants", text: "Natural-looking, long-lasting replacements for missing teeth, planned with precision.", reason: "implants" },
  { icon: Zap, title: "Painless Laser Dentistry", text: "Laser-assisted gum and soft-tissue care with less discomfort and faster healing.", reason: "laser-gum" },
  { icon: Sparkles, title: "Cosmetic Dentistry & Smile Design", text: "Whitening, veneers and smile makeovers designed around your face and goals.", reason: "cosmetic-smile" },
  { icon: Activity, title: "Root Canal Treatment", text: "Gentle, step-by-step root canal care to save the tooth and stop the pain.", reason: "tooth-pain-rct" },
  { icon: Layers, title: "Full Mouth Rehabilitation", text: "Restoring function and aesthetics across the whole mouth with a staged plan.", reason: "implants" },
];

export const Services = ({ onBook }) => (
  <section className="bg-white border-y border-slate-100" id="services" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
      <div className="grid lg:grid-cols-[0.8fr_1.2fr] gap-6 lg:gap-16 mb-10">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-teal-light mb-3">Treatments</p>
          <h2 className="text-3xl sm:text-4xl font-semibold text-ink">Complete dental care, under one calm roof</h2>
        </div>
        <p className="text-ink-muted text-base md:text-lg lg:pt-10">Every journey starts with a thorough consultation and diagnosis. You'll get an honest explanation of your options before any treatment begins.</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map(({ icon: I, title, text, reason }, i) => (
          <article key={title} className="group rounded-3xl border border-slate-200/80 bg-alabaster p-7 flex flex-col hover:bg-mint/50 hover:border-mint-border transition-colors duration-300" data-testid={`service-card-${i}`}>
            <span className="h-12 w-12 rounded-2xl bg-white border border-mint-border grid place-items-center text-teal group-hover:bg-teal group-hover:text-white transition-colors"><I className="h-5 w-5" /></span>
            <h3 className="mt-5 text-xl font-semibold text-ink">{title}</h3>
            <p className="mt-2 text-sm text-ink-muted flex-1">{text}</p>
            <button type="button" onClick={() => onBook(reason)} data-testid={`service-book-${i}`}
              className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-teal hover:gap-3 transition-[gap]">
              Book Consultation <ArrowRight className="h-4 w-4" />
            </button>
          </article>
        ))}
      </div>
    </div>
  </section>
);
